<template>
  <b-modal
    id="alert-info-modal"
    ref="modal"
    centered
    class="full-screen-modal"
    hide-footer
    hide-header
    ok-variant="primary">
    <div>
      <div class="col-12 custom-col-12 ">
        <div id="container-title-modal-alert-info" class="d-flex align-items-center justify-content-center">
          <i class="ph-custom ph-question mr-2 ph-custom-question-alert-info-modal"></i>
        </div>
      </div>
      <h4 class="page-subtitle text-white">{{ $t('alert.info.title') }}</h4>
      <p id="custom-p-modal-alert-info" class=" mt-3 mb-3"
         v-html="$t('alert.info.description')"></p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AlertInfoModal"
}
</script>

<!-- not scoped car modal -->
<style>
#alert-info-modal .modal-content,
#alert-info-modal .modal-body {
  background-color: var(--main-black-dark) !important;
  border-radius: 15px;
}

#alert-info-modal .modal-body {
  padding: 0 !important;
}

#container-title-modal-alert-info {
  padding-bottom: 1em;
}

#custom-p-modal-alert-info {
  margin-bottom: 0;
  color: var(--main-grey-medium);
}

.ph-custom-question-alert-info-modal {
  font-size: 60px !important;
  color: var(--main-grey-medium);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/search/AlertInfoModal.vue